import { render, staticRenderFns } from "./ProjectCompletedLifecycleSetter.vue?vue&type=template&id=13055614"
import script from "./ProjectCompletedLifecycleSetter.vue?vue&type=script&lang=ts"
export * from "./ProjectCompletedLifecycleSetter.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports